import React, { createContext, useContext, useState } from 'react'
import AssessmentExecutionTracking from './AssessmentExecutionTracking'
import { useQuery } from '@tanstack/react-query'
import { getAssessmentExecutionFetch } from 'store/middlewares/assessment.crud'
import { useSelector } from 'react-redux'
import { getCurrentSemesterAndYear } from 'utils/general'
import { secretStorage } from 'config'
import { sumBy } from 'lodash'
import { affiliationGroupNames } from 'keys/affiliationGroups'
import { SystemReviewContext } from '../SystemReviewContext'
import qc from 'keys/queryClient'

const AssessmentExecutionTrackingPage = () => {
    const { grades } = useSelector(state => state.testTaker)
    const { roleIndex } = useSelector(state => state.user)

    const { appliedAssessmentFilters } = useContext(SystemReviewContext)

    const storage = secretStorage.getItem("user")
    const { user_data } = storage || {}
    const { affiliations, affiliation_groups } = user_data?.[roleIndex]?.user_data || {}
    const filterAffiliationGroups = affiliation_groups?.filter(group => affiliationGroupNames.includes(group.name))

    const [date, setDate] = useState(null)
    const [groupTab, setGroupTab] = useState(0)
    const [colorMapping, setColorMapping] = useState({});
    const [semesterAndYear, setSemesterAndYear] = useState(getCurrentSemesterAndYear())
    const [totalTestTakers, setTotalTestTakers] = useState(0)
    // const [order, setOrder] = useState(orderBtns[0].key)

    const { data: cities = [] } = useQuery({
        queryKey: [qc.cities],
        enabled: false
    })

    const isLoading = !filterAffiliationGroups?.length


    const affiliationsData = useQuery({
        queryKey: [qc.assessmentExecution, appliedAssessmentFilters, semesterAndYear],
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentExecutionFetch({
                ...appliedAssessmentFilters,
                semester_and_year: semesterAndYear,
            }, signal)

            const test_taker_execution_count = sumBy(data, 'test_taker_count')
            setTotalTestTakers(test_taker_execution_count)

            return data
        },
        enabled: !isLoading
    })

    const commonValue = {
        totalTestTakers,
        date, setDate,
        colorMapping, setColorMapping,
        groupTab, setGroupTab,
        data: affiliationsData,
        semesterAndYear, setSemesterAndYear,
        affiliations, affiliationGroups: filterAffiliationGroups, grades, cities,
    }

    return (
        <AssessmentExecutionTrackingContext.Provider value={commonValue}>
            <AssessmentExecutionTracking />
        </AssessmentExecutionTrackingContext.Provider>
    )
}

export const AssessmentExecutionTrackingContext = createContext()
export default AssessmentExecutionTrackingPage